export default "__VITE_PUBLIC_ASSET__f1fdc4ed__"